import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

interface DiagnosisDetails {
    athltId: any;
    injId: any;
}

const Diagnosis: React.FC<DiagnosisDetails> = ({ athltId, injId }) => {

    const [centerId, setCenterId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [injuryId, setInjuryId] = useState("");
    const [diagnosisId, setDiagnosisId] = useState("");
    const [dateOfDiagnosis, setDateOfDiagnosis] = useState("");
    const [provDiag, setProvDiag] = useState("");
    const [addNotes, setAddNotes] = useState("");
    const [referrals, setReferrals] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [diagnosisList, setDiagnosisList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [injuryList, setInjuryList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchCenters() {
            setIsLoading(true);
            // const centersResponse = await func.listGeoCenters();
            // setCenterList(Array.isArray(centersResponse) ? centersResponse : [])
            const response = await func.listActiveAthletes();
            setAthleteList(Array.isArray(response) ? response : [])
            const diagnosisResponse = await func.listInjuryDiagnosis(athltId);
            setDiagnosisList(Array.isArray(diagnosisResponse) ? diagnosisResponse : []);
            setShowTable(true)
            setIsLoading(false);
        }
        fetchCenters();
    }, [])

    const filteredData = diagnosisList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });


    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateofDiagnosis)}</span>
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const injDateRender = (rowData) => {
        return <span>{formatDate(rowData.dateOfInjury)}</span>
    };

    const provDiagRender = (rowData) => {
        return <span>{rowData.provisionalDiagnosis}</span>
    };

    const notesRender = (rowData) => {
        return <span>{rowData.additionalNotes}</span>
    };

    const referralsRender = (rowData) => {
        return <span>{rowData.referralsIfNeeded}</span>
    };

    const injuryDiagnosisStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editInjuryDiagnosis(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.injuryDiagnosisId;
        return (
            <Link to="#" onClick={() => deleteInjuryDiagnosis(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newInjuryDiagnosis() {
        setIsEdit(false);
        setOpenModal(true);
        setCenterId("");
        setAthleteId("");
        setInjuryId("");
        setDateOfDiagnosis("");
        setProvDiag("");
        setAddNotes("");
        setReferrals("");
    }


    async function editInjuryDiagnosis(rowData) {
        // const injuryResponse = await func.listInjury(rowData.athleteId);
        // setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
        setDiagnosisId(rowData.diagnosisId)
        setDateOfDiagnosis(rowData.dateofDiagnosis)
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setProvDiag(rowData.provisionalDiagnosis);
        setAddNotes(rowData.additionalNotes);
        setReferrals(rowData.referralsIfNeeded);
        setIsEdit(true)
        setOpenModal(true)
    }

    function deleteInjuryDiagnosis(injuryId: string) {
        const delteInjury = api.InjuryDiagnosis + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjuryAssessment();
            } else {
                const formData = new FormData();
                // formData.append("centerId", centerId);
                formData.append("athleteId", athltId);
                formData.append("injuryId", injId);
                formData.append("dateofDiagnosis", dateOfDiagnosis);
                formData.append("provisionalDiagnosis", provDiag);
                formData.append("additionalNotes", addNotes);
                formData.append("referralsIfNeeded", referrals);

                const createInjDiag = api.InjuryDiagnosis;
                fetch(createInjDiag, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateInjuryAssessment() {
        const formData = new FormData();
        // formData.append("centerId", centerId);
        formData.append("athleteId", athleteId);
        formData.append("injuryId", injuryId);
        formData.append("dateofDiagnosis", dateOfDiagnosis);
        formData.append("provisionalDiagnosis", provDiag);
        formData.append("additionalNotes", addNotes);
        formData.append("referralsIfNeeded", referrals);

        const updateInjDiag = api.InjuryDiagnosis + "/" + diagnosisId;
        fetch(updateInjDiag, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }


    return (
        <>
            {
                isLoading && (
                    <div id="global-loader">
                        <div className="loader-img">
                            <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                        </div>
                    </div>
                )
            }
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Diagnosis</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjuryDiagnosis() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury Diagnosis">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="row">
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const diagnosisResponse = await func.listInjuryDiagnosis(e.value);
                                                    setDiagnosisList(Array.isArray(diagnosisResponse) ? diagnosisResponse : []);
                                                    setShowTable(true)
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete"
                                                    body={athleteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofInjury"
                                                    header="Injury Date"
                                                    body={injDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofDiagnosis"
                                                    header="Diagnosis Date"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="provisionalDiagnosis"
                                                    header="Provisional Diagnosis"
                                                    body={provDiagRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="additionalNotes"
                                                    header="Notes"
                                                    body={notesRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="referralsIfNeeded"
                                                    header="Referrals"
                                                    body={referralsRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryDiagnosisStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Diagnosis</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            {!isEdit && (
                                <>
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const injuryResponse = await func.listInjury(e.value);
                                                    setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                </>
                            )}
                            {/* <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Injury</label>
                                    <Select
                                        value={injuryList.find(inj => inj.injuryId === injuryId) ? {
                                            value: injuryId,
                                            label: formatDate(injuryList.find(inj => inj.injuryId === injuryId).dateOfInjury)
                                        } : null}
                                        onChange={async (e) => {
                                            setInjuryId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        isDisabled={isEdit}
                                        placeholder="Select Injury"
                                        options={injuryList.map(inj => ({
                                            value: inj.injuryId,
                                            label: formatDate(inj.dateOfInjury)
                                        }))}>
                                    </Select>
                                </div>
                            </div> */}
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Date Of Diagnosis</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateOfDiagnosis"
                                        value={dateOfDiagnosis}
                                        onChange={(e) => { setDateOfDiagnosis(e.target.value) }}
                                        placeholder="Enter Date of Diagnosis" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Provisional Diagnosis</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="provDiag"
                                        value={provDiag}
                                        onChange={(e) => { setProvDiag(e.target.value) }}
                                        placeholder="Enter Provisional Diagnosis" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Additional Notes</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="addNotes"
                                        value={addNotes}
                                        onChange={(e) => { setAddNotes(e.target.value) }}
                                        placeholder="Enter Notes" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Referrals if needed</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="referrals"
                                        value={referrals}
                                        onChange={(e) => { setReferrals(e.target.value) }}
                                        placeholder="Enter Referrals" />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Diagnosis;